import { render, staticRenderFns } from "./HeaderWizard.vue?vue&type=template&id=b5705de2&scoped=true"
import script from "./HeaderWizard.vue?vue&type=script&lang=js"
export * from "./HeaderWizard.vue?vue&type=script&lang=js"
import style0 from "./HeaderWizard.vue?vue&type=style&index=0&id=b5705de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5705de2",
  null
  
)

export default component.exports